/* The Projects section home. On the redesign surface (navigation-redesign.md
   NR8) it opens straight onto the persistent records table; on release it
   stays the ported renderSectionHome — the nav bar alone, no record cards
   (DIR7) — byte-for-byte. Mounted only when `state.view === "projects"` and
   no project is open; an open project's area pages are ProjectAreaView. */
import type { JSX } from "react";
import { useAppState } from "../shell/store";
import { SectionHome } from "./SectionHome";
import { RecordsTable } from "./RecordsTable";

export function ProjectsView(): JSX.Element {
  const { store } = useAppState();
  return store.on("nav-redesign") ? (
    <RecordsTable noun="project" loadWhat="projects" />
  ) : (
    <SectionHome noun="project" loadWhat="projects" />
  );
}
